// docs: https://github.com/altostra/type-validations#readme
import { enumOf, maybe, objectOf, arrayOf } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementLandingPagesDataResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      landing_page_id: string,
      name: string,
      description: string,
      marked_as_deleted: boolean,
      enabled: boolean,
      last_edited: number,
      last_edited_by: string,
      created_by: string,
      status: string,
      impressions: number,
      form_submissions: number,
      size_limit_status: maybe(enumOf("ok", "blocked", "warning"), true),
      size_limit_status_updated_at: maybe(number, true),
    })
  ),
});
